import aboutus from "../../assets/aboutus.jpeg";
import ownerImg from "../../assets/owner.jpeg";

import img1 from "../../assets/location.jpeg";
import img2 from "../../assets/contact.jpeg";
import img3 from "../../assets/email.jpeg";
import img4 from "../../assets/message.jpeg";
import order from "../../assets/order.png";
import delivery from "../../assets/delivery.jpeg";
import food from "../../assets/food.png";
// import cafeBg from "../../assets/cafesectionbg.jpeg";

const AboutScreen = () => {
  return (
    <div className="w-full">

      {/* HERO SECTION */}
      <div className="relative h-[300px] sm:h-[380px] lg:h-[460px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${aboutus})` }}
        />
        <div className="absolute inset-0 bg-black/50" />

        <div className="relative z-10 flex h-full items-center justify-center">
          <h1 className="text-primary-50 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-wide">
            About Us
          </h1>
        </div>
      </div>

      {/* OWNER STORY */}
      <div className="px-6 sm:px-10 lg:px-20 py-24 bg-background-soft" >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center max-w-6xl mx-auto">
          <div className="flex justify-center">
            <img
              src={ownerImg}
              alt="Owner"
              className="w-full max-w-sm rounded-2xl shadow-xl object-cover"
            />
          </div>

          <div className="text-primary-800 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl font-italianno font-semibold">
              Meet the Owner
            </h2>

            <div className="flex justify-center lg:justify-start mt-4 mb-6">
              <span className="w-16 h-[1px] bg-primary-800/60" />
            </div>

            <p className="text-base sm:text-lg leading-relaxed mb-4">
              Eelaa Cafe began as a dream — a place where comforting aromas,
              handcrafted recipes, and warm conversations come together.
            </p>

            <p className="text-base sm:text-lg leading-relaxed mb-4">
              Every detail, from sourcing fresh ingredients to creating a cozy
              atmosphere, reflects our passion for thoughtful hospitality.
            </p>

            <p className="text-base sm:text-lg leading-relaxed">
              We believe a cafe should feel like home — familiar, welcoming,
              and full of heart.
            </p>

            <p className="text-5xl font-italianno mt-6 text-primary-700">
              ~ Jasmin
            </p>
          </div>
        </div>
      </div>

      {/* DISCOVER OUR STORY */}
      <div className="relative py-32 px-6 sm:px-10 lg:px-20 bg-primary-900">
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-primary-100 rounded-xl shadow-2xl p-10 sm:p-14">

            {/* OUTSIDE BORDER EFFECT */}
            <div className="absolute inset-0 -translate-x-5 -translate-y-5 border-2 border-primary-100"></div>
            <div className="absolute inset-0 translate-x-5 translate-y-5 border-2 border-primary-100"></div>

            <div className="relative z-10 text-center sm:text-left">
              <p className="uppercase tracking-widest text-xs text-primary-500 mb-2">
                Discover
              </p>

              <h2 className="text-4xl sm:text-5xl font-italianno text-primary-900 mb-6">
                Our Story
              </h2>

              <p className="text-primary-700 leading-relaxed mb-4">
                Eelaa Cafe was created for those who cherish slow mornings,
                comforting flavors, and meaningful conversations.
              </p>

              <p className="text-primary-700 leading-relaxed">
                From handpicked ingredients to thoughtfully curated spaces,
                every detail is designed to make you feel present, relaxed,
                and at home.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* INFO CARDS SECTION */}
      <div
        className="relative overflow-hidden py-20 px-6 sm:px-10 lg:px-20"
        style={{
          backgroundImage: `url(${aboutus})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: window.innerWidth > 0 ? "fixed" : "scroll",
        }}
      >
        <div className="absolute inset-0 bg-primary-900/40"></div>

        <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* CARD 1 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className=" mx-auto mb-4 flex items-center justify-center  text-primary-700">
             <img src={order} alt="order" className="w-20 h-15" />
            </div>
            <h3 className="text-lg font-semibold text-primary-900 mb-2">
              Your Order
            </h3>
            <p className="text-sm text-primary-700">
              There are many variations of passages of Lorem Ipsum available.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className=" mx-auto mb-4 flex items-center justify-center  text-primary-700">
             <img src={delivery} alt="delivery" className="w-20 h-15" />
            </div>
            <h3 className="text-lg font-semibold text-primary-900 mb-2">
              We Deliver
            </h3>
            <p className="text-sm text-primary-700">
              Fast and safe delivery with carefully packed fresh food.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className=" mx-auto mb-4 flex items-center justify-center  text-primary-700">
             <img src={food} alt="food" className="w-20 h-15" />
            </div>
            <h3 className="text-lg font-semibold text-primary-900 mb-2">
              Enjoy Fresh Food
            </h3>
            <p className="text-sm text-primary-700">
              Prepared fresh every day with quality ingredients.
            </p>
          </div>

        </div>
      </div>

      {/* CONTACT STRIP */}
      <div className="px-6 sm:px-10 lg:px-20 py-20 bg-primary-50">
        <div className="bg-white/90 backdrop-blur-md shadow-xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-primary-200 max-w-6xl mx-auto">
          {[
            { img: img1, text: "Eelaa Café, Satara, Maharashtra" },
            { img: img2, text: "01234 56789" },
            { img: img3, text: "eelaacafe@gmail.com" },
            { img: img4, text: "Drop us a line anytime" },
          ].map((item, index) => (
            <div
              key={index}
              className="p-8 text-center hover:bg-primary-50 transition"
            >
              <img
                src={item.img}
                alt=""
                className="w-12 h-12 mx-auto mb-4 opacity-80"
              />
              <p className="text-primary-800 text-sm leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default AboutScreen;
